import { AfterViewInit, Directive, ElementRef, Renderer2 } from '@angular/core';

import { EnvUtils } from '@ecm/dispatcher';

/**
 * This directive sets target attribute on <a> dom element
 * _self on webview mode (mandatory value for OEM)
 * _blank for other mode (eclair, normal...)
 */
@Directive({
    selector: 'a[ecmTarget]',
    standalone: true,
})
export class MaterialTargetDirective implements AfterViewInit {
    /**
     * Constructor
     * @param {ElementRef} element
     * @param {Renderer2} renderer
     */
    public constructor(
        private element: ElementRef,
        private renderer: Renderer2,
    ) {}

    /**
     * Directive initialization
     */
    public ngAfterViewInit(): void {
        const DOMElement: any = this.element.nativeElement;
        this.renderer.setAttribute(DOMElement, 'target', EnvUtils.isWebview() ? '_self' : '_blank');
        this.renderer.setAttribute(DOMElement, 'rel', 'noopener');
    }
}
